import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('contactNameField');

    return {
        CONTACT_NAME_FIELD_LABEL: t('contactNameFieldLabel')
    };
};

export default useTranslation;
